import FileUpload from 'lib/components/FileUpload';
import { useBooleanFlag } from 'utils/flags';
import { LaunchDarklyFlags } from 'lib/types/launchDarklyFlags';
import Firebase from 'EnoticeFirebase';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { selectActiveOrganization, selectUser } from 'redux/auth';
import { FileWithUploadRef } from 'lib/frontend/hooks/useFirebaseStorageUpload';
import ToastActions from 'redux/toast';
import { handleFileMetadataUpload } from '../ClipArtLibrary/clipArtHelpers';
import ClipArtLibrary from '../ClipArtLibrary';

const getClipArtStoragePathForOrganization = (organizationId: string) =>
  `documentcloud/clipArt/${organizationId}`;

const storage = Firebase.storage();

function ClipArtManager({ folder }: { folder: string }) {
  const activeOrganization = useAppSelector(selectActiveOrganization);
  const user = useAppSelector(selectUser);
  const useColumnCDN = useBooleanFlag(LaunchDarklyFlags.ENABLE_COLUMN_CDN);
  const dispatch = useAppDispatch();
  const [recentlyUploaded, setRecentlyUploaded] = useState(new Array<string>());

  async function onFileUpload(filesAndRefs: FileWithUploadRef[]) {
    if (!activeOrganization || !user) {
      return;
    }

    const [error] = await handleFileMetadataUpload({
      filesAndRefs,
      folder,
      activeOrganization: activeOrganization.ref,
      user: user.ref,
      useColumnCDN
    });

    if (error) {
      return dispatch(
        ToastActions.toastError({
          headerText: 'Error uploading files',
          bodyText: 'One or more files failed to upload. Please try again.'
        })
      );
    }

    setRecentlyUploaded([
      ...recentlyUploaded,
      ...filesAndRefs.map(o => o.uploadRef.fullPath)
    ]);
  }

  if (!activeOrganization) {
    return null;
  }

  return (
    <>
      <FileUpload
        id={`clip-art-upload-${folder.replace(/\//g, '-')}`}
        uploadFolder={getClipArtStoragePathForOrganization(
          activeOrganization.id
        )}
        storage={storage}
        onFileUpload={onFileUpload}
      />
      <ClipArtLibrary
        organizationId={activeOrganization.id}
        folder={folder}
        uploads={recentlyUploaded}
      />
    </>
  );
}

export default ClipArtManager;
